export const investorTypeOptions = [
    "Conservative",
    "Moderate",
    "Aggressive",
];
//# sourceMappingURL=investorType.js.map